module.exports = __webpack_public_path__ + "img/malbec.721f7aa5.jpg";